lmApp.directive('lmEditEpisode', [function () {
  return {
    restrict: 'E',
    controller: 'LmEditEpisodeController',
    replace: true,
    templateUrl: 'lm-asset-edit/tv-episode/edit-tv-episode.tpl.html'
  };
}]);
lmApp
  .controller('LmEditEpisodeController', ['$scope', '$rootScope', '$templateCache', '$compile', '$q', '$timeout', 'MetadataService', 'AssetService', 'ToastService', 'AssetResource', 'GenreResource', 'PersonResource', 'ContentNodeResource', 'ValidatorService',
    function ($scope, $rootScope, $templateCache, $compile, $q, $timeout, MetadataService, AssetService, ToastService, AssetResource, GenreResource, PersonResource, ContentNodeResource, ValidatorService) {
      $scope.episode = {
        id: 0,
        extid: '',
        type: 'episode',
        rotationStart: moment.utc().subtract(1, 'day'),
        rotationFinish: moment.utc().add(1, 'year'),
        name: '',
        description: '',
        year: '',
        duration: 0,
        imdb: '',
        imdbVoteCount: '',
        kinopoisk: '',
        kinopoiskVoteCount: '',
        adult: false,
        ageLimit: '',
        genres: [],
        person: {},
        persons: [],
        poster: {
          state: '',
          url: '',
          source: ''
        },
        landscapePoster: {
          state: '',
          url: '',
          source: '',
        },
        streamResources: [],
        seriesId: 0,
        seriesName: '',
        season: {
          id: 0
        },
        index: 0,
        mpaa: '',
        vastId: '',
      };

      $scope.newPerson = {
        firstName: '',
        lastName: '',
        role: ''
      };
      $scope.showPersonForm = false;

      $scope.genres = [];
      $scope.persons = [];
      $scope.seasons = [];
      $scope.roles = [
        {
          title: 'Actor',
          id: 'actor'
        },
        {
          title: 'Composer',
          id: 'composer'
        },
        {
          title: 'Director',
          id: 'director'
        },
        {
          title: 'Operator',
          id: 'operator'
        },
        {
          title: 'Producer',
          id: 'producer'
        },
        {
          title: 'Presenter',
          id: 'presenter'
        },
        {
          title: 'Scenario',
          id: 'scenario'
        },
        {
          title: 'Editor',
          id: 'editor'
        },
        {
          title: 'Writer',
          id: 'writer'
        },
        {
          title: 'Guest',
          id: 'guest'
        },
        {
          title: 'Assembly',
          id: 'assembly'
        },
        {
          title: 'Artist',
          id: 'artist'
        },
        {
          title: 'Music Director',
          id: 'music_director'
        },
        {
          title: 'Playback Singers',
          id: 'playback_singers'
        }
      ];

      var saved = {};

      $scope.episode.seriesId = $scope.asset.seriesId || 0;
      $scope.episode.seriesName = $scope.asset.seriesName || '';

      if ($scope.asset.id && $scope.asset.id > 0) {
        $scope.episode.id = $scope.asset.id;

        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        var params = {};
        params['id[eq]'] = $scope.asset.id;
        params['$expand'] = 'resources(url),genres,persons';
        AssetResource.get(params).$promise
            .then(function (result) {
              if (result.length) {
                processAsset(result[0]);
                saved = angular.copy(result[0]);

                AssetService.GetAssetById($scope.asset.id)
                    .then(function (assets) {
                      if (assets.length) {
                        var a = assets[0];
                        if (a.tv_series_episode) {
                          AssetResource.get({'id[eq]': a.tv_series_episode.series_id, '$expand': 'series_seasons,conditions'}).$promise
                              .then(function (series) {
                                if (series.length) {
                                  $scope.episode.seriesId = a.tv_series_episode.series_id;
                                  $scope.episode.seriesName = series[0].name;
                                  //$scope.episode.rotationStart = moment(series[0].rotation_start);
                                  //$scope.episode.rotationFinish = moment(series[0].rotation_finish);
                                  for (var i = 0; i < series[0].series_seasons.length; i++) {
                                    var season = series[0].series_seasons[i];
                                    if (season.id === $scope.episode.season.id) {
                                      $scope.episode.season = processSeason(season);
                                    }
                                    $scope.seasons.push(processSeason(season));
                                  }
                                }
                              })
                              .catch(function (reason) {
                                $rootScope.debugInfo(reason, 'silent');
                              });
                        }
                      }
                    })
                    .catch(function (reason) {
                      $rootScope.debugInfo(reason, 'silent');
                    });


              } else {
                ToastService.Small({
                  title: 'Error getting episode',
                  color: 'red',
                  icon: 'cloud-check'
                }, 1000 * 6);
                $scope.close();
              }
              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;
            })
            .catch(function (reason) {
              ToastService.Small({
                title: 'Error getting episode',
                color: 'red',
                icon: 'cloud-check'
              }, 1000 * 6);
              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;
              $scope.close();
            });
      } else {
        AssetResource.get({'id[eq]': $scope.episode.seriesId, '$expand': 'series_seasons,conditions'}).$promise
            .then(function (series) {
              if (series.length) {
                $scope.episode.seriesName = series[0].name;
             //   $scope.episode.rotationStart = moment(series[0].rotation_start);
               // $scope.episode.rotationFinish = moment(series[0].rotation_finish);
                for (var i = 0; i < series[0].series_seasons.length; i++) {
                  var season = series[0].series_seasons[i];
                  if (season.id === $scope.episode.season.id) {
                    $scope.episode.season = processSeason(season);
                  }
                  $scope.seasons.push(processSeason(season));
                }
              }
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
            });
      }

      var processGenre = function(genre) {
        return {
          id: genre.id,
          title: genre.name
        };
      };

      var processSeason = function(season) {
        return {
          id: season.id,
          title: season.name
        };
      };

      var processPerson = function(person) {
        return {
          id: person.id,
          firstName: person.first_name,
          lastName: person.last_name,
          role: person.role
        }
      };

      var processAsset = function(asset) {
        $scope.episode.extid = asset.ext_id;
        $scope.episode.name = asset.name;
        $scope.episode.description = asset.description;
        $scope.episode.year = asset.year;
        $scope.episode.duration = asset.duration || 0;
        $scope.episode.imdb = asset.imdb || '';
        $scope.episode.imdbVoteCount = asset.imdb_vote_count || '';
        $scope.episode.kinopoisk = asset.kinopoisk || '';
        $scope.episode.kinopoiskVoteCount = asset.kinopoisk_vote_count || '';
        $scope.episode.adult = asset.adult || false;
        $scope.episode.ageLimit = asset.age_limit || '';
        var genres = asset.genres || [];
        $scope.episode.genres = genres.map(processGenre);
        var persons = asset.persons || [];
        $scope.episode.persons = persons.map(processPerson);
        $scope.episode.season.id = asset.episode_season_id;
        $scope.episode.index = asset.episode_index;
        $scope.episode.mpaa = asset.mpaa || '';
        $scope.episode.vastId = asset.vast_id || '';

        $scope.episode.rotationStart = moment(asset.rotation_start);
        $scope.episode.rotationFinish = moment(asset.rotation_finish);

        if (asset.resources) {
          for (var i = 0; i < asset.resources.length; i++) {
            var r = asset.resources[i]
            if (r.type === 'picture') {
              if (r.category === 'poster_blueprint') {
                $scope.episode.poster.state = r.state;
                $scope.episode.poster.url = r.url;
                $scope.episode.poster.source = r.source;
              }
              if (r.category === 'landscape') {
                $scope.episode.landscapePoster.state = r.state;
                $scope.episode.landscapePoster.url = r.url;
                $scope.episode.landscapePoster.source = r.source;
              }
              continue
            }
            var pr = {
              id: r.id,
              type: r.type,
              state: r.state,
              deployer: r.deployer,
              preparer: r.preparer,
              added: r.create_time,
              private: r.private || false,
              URL: r.source,
              category: r.category,
              tags: '',
              group: r.group_id,
              deployerArgs: r.deployer_args,
            }
            if (r.deployer_args && r.deployer_args.cdn_tag) {
              pr.tags = r.deployer_args.cdn_tag;
            }
            $scope.episode.streamResources.push(pr)
          }
        }
      };

      var getMeta = function() {
        GenreResource.get().$promise
            .then(function (genres) {
              var genreList = [];
              for (var i = 0; i < genres.length; i++) {
                var genre = genres[i];
                genreList.push({
                  id: genre.id,
                  title: genre.name
                });
              }
              $scope.genres = genreList;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
            });
      };

      getMeta();

      var searchTimeout;
      $scope.findPersonLoading = false;
      $scope.findPerson = function(text) {
        if (!text) return;
        text = text.trim();
        if (text === '') return;
        if (searchTimeout) $timeout.cancel(searchTimeout);
        $scope.findPersonLoading = true;
        searchTimeout = $timeout(function () {
          AssetService.SearchPerson(text)
              .then(function (persons) {
                var personList = [];
                for (var i = 0; i < persons.length; i++) {
                  var person = persons[i];
                  personList.push({
                    id: person.id,
                    title: person.first_name + ' ' + person.second_name + ' (' + person.role + ')',
                    firstName: person.first_name,
                    lastName: person.second_name,
                    role: person.role
                  });
                }
                $scope.persons = personList;
                $scope.findPersonLoading = false;
              })
              .catch(function (reason) {
                $rootScope.debugInfo(reason, 'silent');
              });
        }, 650);
      };

      $scope.addPersonToList = function(person) {
        $scope.episode.person = {};
        for (var i = 0; i < $scope.episode.persons.length; i++) {
          if ($scope.episode.persons[i].id === person.id) return;
        }
        $scope.episode.persons.push(person);
      };

      $scope.cdnTags = [];
      $scope.getCDNTags = function () {
        return ContentNodeResource.get().$promise
            .then(function (origins) {
              for (var i = 0; i < origins.length; i++) {
                var origin = origins[i];
                if (!origin.cdn) {
                  continue
                }
                for (var j = 0; j < origin.cdn.length; j += 1) {
                  if (!origin.cdn[j].tag) continue;
                  $scope.cdnTags.push(origin.cdn[j].tag)
                }
              }
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
            });
      };
      $scope.getCDNTags();

      $scope.openMediaManager = function (type, resource) {
        if ($scope.loading) return;
        MetadataService.MediaManager2($scope.episode, $scope, type, resource, $scope.cdnTags);
      };

      $scope.deletePerson = function(person) {
        for (var i = 0; i < $scope.episode.persons.length; i++) {
          if (person.id === $scope.episode.persons[i].id) {
            $scope.episode.persons.splice(i, 1);
            return;
          }
        }
      };

      $scope.deleteStream = function($index) {
        $scope.episode.streamResources.splice($index, 1);
      };

      $scope.togglePersonForm = function() {
        $scope.showPersonForm = !$scope.showPersonForm;
      };

      $scope.createPerson = function() {
        $scope.personValidateErrors = {};

        var valid = true;
        if (!_.trim($scope.newPerson.firstName)) {
          $scope.personValidateErrors.firstName = true;
          valid = false;
        }
        if (!_.trim($scope.newPerson.lastName)) {
          $scope.personValidateErrors.lastName = true;
          valid = false;
        }
        if (!$scope.newPerson.role.id) {
          $scope.personValidateErrors.role = true;
          valid = false;
        }
        if (!valid) return;

        PersonResource.create(normPersonToJson($scope.newPerson)).$promise
            .then(function (response) {
              $scope.addPersonToList(processPerson(response.data));
              $scope.togglePersonForm();
              $scope.newPerson = {
                firstName: '',
                lastName: '',
                role: ''
              };
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
              ToastService.Small({
                title: 'Failed to create person: ' + _.get(reason, 'data.error.message', 'server error'),
                color: 'red',
                icon: 'delete'
              }, 30 * 1000);
            });
      };

      var normPersonToJson = function(person) {
        return {
          first_name: person.firstName,
          last_name: person.lastName,
          role: person.role.id
        }
      };

      var normStreamResourceToJson = function (stream) {
        var resource = {
          type: stream.type, // dash, hls, youtube+video, megogo
          category: stream.category,
          group_id: stream.group,
          source: stream.URL,
          preparer: stream.preparer,
          private: stream.private,
          deployer: stream.deployer
        };
        if (stream.deployerArgs) {
          resource.deployer_args = stream.deployerArgs;
        }
        if (stream.tags) {
          if (!resource.deployer_args) resource.deployer_args = {}
          resource.deployer_args.cdn_tag = stream.tags
        }
        return resource
      };

      var normEpisodeToJson = function(episode) {
        var processed = {
          ext_id: 'personal:' + translit(episode.name) + (episode.year || '') + ':' + CryptoJS.MD5(episode.name + (episode.year || '')).toString(CryptoJS.enc.Hex) + ':' + guid(),
          type: 'episode',
          name: _.trim(episode.name),
          description: _.trim(episode.description),
          year: parseInt(episode.year),
          duration: parseInt(episode.duration),
          genres: episode.genres,
          persons: episode.persons,
          adult: episode.adult,
          age_limit: parseInt(episode.ageLimit || 0),
          imdb: parseFloat(episode.imdb || 0),
          imdb_vote_count: parseInt(episode.imdbVoteCount || 0),
          kinopoisk: parseFloat(episode.kinopoisk || 0),
          kinopoisk_vote_count: parseInt(episode.kinopoiskVoteCount || 0),
          resources: [],
          episode_season_id: episode.season.id,
          episode_index: parseInt(episode.index),
          rotation_start: episode.rotationStart.format(),
          rotation_finish: episode.rotationFinish.format(),
          mpaa: episode.mpaa,
          vast_id: episode.vastId,
        };
        if (!processed.year) {
          processed.year = 0;
        }
        if (episode.poster.source) {
          processed.resources.push({
            type: 'picture',
            category: 'poster_blueprint',
            group_id: 'picture',
            source: episode.poster.source,
            preparer: 'passthrough',
            deployer: 'origin'
          });
        }
        if (episode.landscapePoster.source) {
          processed.resources.push({
            type: 'picture',
            category: 'landscape',
            group_id: 'picture',
            source: episode.landscapePoster.source,
            preparer: 'passthrough',
            deployer: 'origin'
          });
        }
        for (var i = 0; i < episode.streamResources.length; i++) {
          processed.resources.push(normStreamResourceToJson(episode.streamResources[i]));
        }
        return processed;
      };

      var isAssetValid = function() {
        $scope.episodeValidateErrors = {};

        var valid = true;
        if (!_.trim($scope.episode.name)) {
          $scope.episodeValidateErrors.name = true;
          valid = false;
        }
        if ($scope.episode.season.id === 0) {
          $scope.episodeValidateErrors.seasonId = true;
          valid = false;
        }
        if ($scope.episode.year && (!ValidatorService.Numerical($scope.episode.year) || $scope.episode.year < 1900)) {
          $scope.episodeValidateErrors.year = true;
          valid = false;
        }
        if ($scope.episode.ageLimit && (!ValidatorService.Numerical($scope.episode.ageLimit) || $scope.episode.ageLimit < 0 || $scope.episode.ageLimit > 18)) {
          $scope.episodeValidateErrors.ageLimit = true;
          valid = false;
        }
        if ($scope.episode.imdb && (!ValidatorService.Numerical($scope.episode.imdb) || $scope.episode.imdb < 0 || $scope.episode.imdb > 10)) {
          $scope.episodeValidateErrors.imdb = true;
          valid = false;
        }
        if ($scope.episode.imdbVoteCount && (!ValidatorService.Numerical($scope.episode.imdbVoteCount) || $scope.episode.imdbVoteCount < 0)) {
          $scope.episodeValidateErrors.imdbVoteCount = true;
          valid = false;
        }
        if ($scope.episode.kinopoisk && (!ValidatorService.Numerical($scope.episode.kinopoisk) || $scope.episode.kinopoisk < 0 || $scope.episode.kinopoisk > 10)) {
          $scope.episodeValidateErrors.kinopoisk = true;
          valid = false;
        }
        if ($scope.episode.kinopoiskVoteCount && (!ValidatorService.Numerical($scope.episode.kinopoiskVoteCount) || $scope.episode.kinopoiskVoteCount < 0)) {
          $scope.episodeValidateErrors.kinopoiskVoteCount = true;
          valid = false;
        }
        if (!ValidatorService.Numerical($scope.episode.index) || $scope.episode.index <= 0) {
          $scope.episodeValidateErrors.index = true;
          valid = false;
        }
        return valid;
      };

      $scope.$parent.createFn = function () {
        if (!isAssetValid()) return;

        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        AssetResource.createEpisode({id: $scope.episode.season.id}, normEpisodeToJson($scope.episode)).$promise
            .then(function (response) {
              ToastService.Small({
                title: 'VOD: <b class="tc-white">' + $scope.episode.name + '</b> successfully created',
                color: 'green',
                icon: 'cloud-check'
              }, 1000 * 6);

              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;

              $scope.close(response.data.id);
            })
            .catch(function (reason) {
              $rootScope.showLinearProgress('#modalLoader');
              $scope.$parent.loading = true;
              $scope.close();
              ToastService.Small({
                title: 'Failed to create asset: ' + _.get(reason, 'data.error.message', 'server error'),
                color: 'red',
                icon: 'delete'
              }, 30 * 1000);
            });
      };

      var compareResources = function(updated) {
        var sourceResourceMap = {};
        if (saved.resources) {
          for (var i = 0; i < saved.resources.length; i++) {
            var r = saved.resources[i];
            var tags = ''
            if (r.deployer_args && r.deployer_args.cdn_tag) {
              tags = r.deployer_args.cdn_tag;
            }
            if (!r.private) r.private = false;
            var key = (r.type + r.category + r.private + tags).toLowerCase();
            sourceResourceMap[key] = r;
          }
        }

        var newResources = [];
        for (var i = 0; i < updated.resources.length; i++) {
          var r = updated.resources[i];
          var tags = ''
          if (r.deployer_args && r.deployer_args.cdn_tag) {
            tags = r.deployer_args.cdn_tag;
          }
          if (!r.private) r.private = false;
          var key = (r.type + r.category + r.private + tags).toLowerCase();
          if (!sourceResourceMap.hasOwnProperty(key)) {
            newResources.push(r);
          } else {
            if (r.source === sourceResourceMap[key].source
                && r.private === sourceResourceMap[key].private
                && r.deployer === sourceResourceMap[key].deployer
                && sourceResourceMap[key].state !== 'deployment-error') {
              newResources.push(sourceResourceMap[key]);
            } else {
              newResources.push(r);
            }
          }
        }
        return newResources;
      };

      $scope.$parent.updateFn = function (asset) {
        if (!isAssetValid()) return;

        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        var updated = normEpisodeToJson($scope.episode);
        updated.resources = compareResources(updated);

        AssetResource.update({id: $scope.episode.id}, updated).$promise
            .then(function (response) {
              ToastService.Small({
                title: 'VOD: <b class="tc-white">' + $scope.episode.name + '</b> successfully updated',
                color: 'green',
                icon: 'cloud-check'
              }, 1000 * 6);

              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;

              $scope.close(response.data.id);
            })
            .catch(function (reason) {
              $rootScope.showLinearProgress('#modalLoader');
              $scope.$parent.loading = true;
              ToastService.Small({
                title: 'Failed to update asset: ' + _.get(reason, 'data.error.message', 'server error'),
                color: 'red',
                icon: 'cloud-outline-off'
              }, 30 * 1000);
              $rootScope.debugInfo(reason);
            });
      }

      }]);
